import { render, staticRenderFns } from "./BlockedUsersList.vue?vue&type=template&id=1498e450"
import script from "./BlockedUsersList.vue?vue&type=script&lang=js"
export * from "./BlockedUsersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports